module.exports = __webpack_public_path__ + "static/media/mail-icon.c00345a7.svg";